function getAccountInfoFromSession() {
  const accountDataInSession = JSON.parse(
    sessionStorage.getItem("accountData")
  );
  if (
    !accountDataInSession?.data ||
    Date.now() > accountDataInSession?.expires
  ) {
    return null;
  }
  return accountDataInSession?.data;
}

const fetchCustomerVip = async () => {
  const customerId = hvgUserId;
  if (!customerId) {
    return null;
  }

  const locale = Shopify.locale;
  const resp = await fetch(
    "https://api.enroutejewelry.com/stamped_customer_v2",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        customerId,
        locale,
      }),
    }
  );
  const res = await resp.json();
  return res;
};

window._erj_ = window._erj_ || {};
window._erj_.getAccountInfo = async () => {
  let data = getAccountInfoFromSession();
  if (!data) {
    data = await fetchCustomerVip();
    sessionStorage.setItem(
      "accountData",
      JSON.stringify({
        data,
        expires: Date.now() + 1000 * 60 * 5,
      })
    );
  }
  return data;
};

async function renderVipAccountInfo() {
  const data = await window._erj_?.getAccountInfo?.();
  if (!data) {
    return;
  }

  let accountInfo = data?.vipTierLocale;
  if (data?.totalPoints) {
    accountInfo +=
      " | " +
      data.totalPoints +
      window._erj_?.getGlobalLocaleStrings()?.account?.points;
  }
  const stampVipDOM = document.querySelector(".account-stamped-vip");
  if (stampVipDOM && accountInfo) {
    stampVipDOM.innerHTML = accountInfo;
  }

  if (!location.pathname.includes("/pages/membership")) {
    return;
  }

  const viptable = document.querySelector(".vip-benefit-table");
  if (!viptable) {
    return;
  }

  const tierConfig = [
    { tier: "Silver", index: 1, bgColor: "#FBFBFB" },
    { tier: "Gold", index: 2, bgColor: "#FEFCF8" },
    { tier: "Diamond", index: 3, bgColor: "#F9F9FA" },
    { tier: "Ambassador", index: 4, bgColor: "#FBFBFB" },
  ];

  const tier = tierConfig.find((item) => item.tier === data?.stampVip);
  if (!tier) {
    return;
  }
  // highlight current tier
  viptable
    .querySelectorAll("td:nth-child(" + (tier.index + 1) + ")")
    .forEach((td) => {
      td.style.backgroundColor = tier.bgColor;
    });
}

window._erj_.renderVipAccountInfo = renderVipAccountInfo;

window.addEventListener("DOMContentLoaded", () => {
  renderVipAccountInfo();
});
